export default "__VITE_ASSET__CPsI1qkD__"